import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const PlusIconThin: FC<PropsT> = ({ fill = 'currentColor' }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.4752 8.52447L1.12762 8.52447C0.871873 8.52447 0.662794 8.31685 0.667056 8.06115C0.668011 8.00386 0.669126 7.97115 0.670189 7.95122C0.684052 7.69119 0.879249 7.47668 1.13964 7.47668L7.4752 7.47668L7.47521 1.12908C7.47521 0.873336 7.68253 0.666016 7.93827 0.666016L8.05994 0.666016C8.31568 0.666015 8.523 0.873336 8.523 1.12908L8.523 7.47668L14.8706 7.47667C15.1263 7.47667 15.3337 7.684 15.3337 7.93974V8.06141C15.3337 8.31715 15.1263 8.52447 14.8706 8.52447L8.523 8.52447L8.523 14.8721C8.523 15.1278 8.31538 15.3369 8.05967 15.3326C8.00238 15.3317 7.96968 15.3305 7.94974 15.3295C7.68972 15.3156 7.4752 15.1204 7.4752 14.86L7.4752 8.52447Z" fill="#909090"/>
    </svg>
);

export default PlusIconThin;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const PlusIconThin: FC<PropsT> = ({ fill = 'currentColor' }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.4752 8.52447L1.12762 8.52447C0.871873 8.52447 0.662794 8.31685 0.667056 8.06115C0.668011 8.00386 0.669126 7.97115 0.670189 7.95122C0.684052 7.69119 0.879249 7.47668 1.13964 7.47668L7.4752 7.47668L7.47521 1.12908C7.47521 0.873336 7.68253 0.666016 7.93827 0.666016L8.05994 0.666016C8.31568 0.666015 8.523 0.873336 8.523 1.12908L8.523 7.47668L14.8706 7.47667C15.1263 7.47667 15.3337 7.684 15.3337 7.93974V8.06141C15.3337 8.31715 15.1263 8.52447 14.8706 8.52447L8.523 8.52447L8.523 14.8721C8.523 15.1278 8.31538 15.3369 8.05967 15.3326C8.00238 15.3317 7.96968 15.3305 7.94974 15.3295C7.68972 15.3156 7.4752 15.1204 7.4752 14.86L7.4752 8.52447Z" fill="#909090"/>
    </svg>
);

export default PlusIconThin;
